/**
 * Returns the dash array needed to make the value fill its part of a line and fill the rest with empty space.
 *
 * @param {number} value
 * @param {number} max
 * @param {number} circumference
 * @return {string}
 */
export function valueToDashArray(value, max, circumference) {
  return `${valueToDashSize(value, max, circumference)} ${valueToDashSize(
    max - value,
    max,
    circumference
  )}`
}

/**
 * Returns the dash size needed to make the value fill its part of a line.
 *
 * @param {number} value The value.
 * @param {number} max The highest possible value.
 * @param {number} lineLength The length of the line to fill.
 * @return {number}
 */
export function valueToDashSize(value, max, lineLength) {
  return (value / max) * lineLength
}
